import Vue from 'vue';
import Vuex from 'vuex';

import people from './modules/people';
import status from './modules/status';

Vue.use( Vuex );
require( 'es6-promise' ).polyfill();

export default new Vuex.Store({
    modules: {
        people, status
    }
});
